import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultTitle: {
    id: 'Embla Carousel',
    defaultMessage: 'Embla Carousel',
  },
});

const emblaCarouselSchema = ({ formData } = {}) => ({
  title: messages.defaultTitle,
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'title',
        'slides',
        'slidesToShow',
        'minSlidesOnMobile',
        'displayMode',
        'autoplay',
        'autoplayDelay',
        'alignment',
        'isFullWidth',
        'outerClassName',
        'loop',
        'hideArrows',
        'hideDots',
        'hideButtons',
        'clickableSlides',
        'hideDescription',
        'showEffectiveDate',
        'equalHeight',
        'backgroundColor',
        'textTone',
      ],
    },
  ],
  properties: {
    outerClassName: {
      title: 'Custom container class',
      description: 'Optional extra class applied on the outer .embla wrapper',
      type: 'string',
    },
    title: {
      title: 'Carousel title (h2)',
      description: 'Optional title shown above the carousel',
      type: 'string',
    },
    slides: {
      title: 'Slides',
      widget: 'object_list',
      schema: {
        title: 'Slide',
        titleField: 'heading',
        fieldsets: [
          {
            id: 'default',
            title: 'Default',
            fields: ['heading', 'content', 'image', 'link', 'buttonText'],
          },
        ],
        properties: {
    outerClassName: {
      title: 'Custom container class',
      description: 'Optional extra class applied on the outer .embla wrapper',
      type: 'string',
    },
          heading: {
            title: 'Heading',
            type: 'string',
          },
          content: {
            title: 'Content',
            type: 'text',
          },
          image: {
            title: 'Image',
            widget: 'object_browser',
            mode: 'image',
            allowExternals: false,
          },
          link: {
            title: 'Link',
            widget: 'object_browser',
            mode: 'link',
            allowExternals: true,
            multi: false,
            default: null,
          },
          buttonText: {
            title: 'Button text',
            type: 'string',
          },
        },
        required: [],
      },
    },
    displayMode: {
      title: 'Display mode',
      type: 'string',
      choices: [
        ['full', 'Full (image + text)'],
        ['image-only', 'Image only'],
        ['image-top', 'Image top (image above content)'],
      ],
      default: 'full',
    },
    alignment: {
      title: 'Text alignment',
      widget: 'align',
      actions: ['left', 'center', 'right'],
      default: 'left',
    },
    isFullWidth: {
      title: 'Full width carousel',
      type: 'boolean',
      default: false,
    },
    loop: {
      title: 'Loop infinitely',
      type: 'boolean',
      default: true,
    },
    slidesToShow: {
      title: 'Slides to show (desktop)',
      type: 'number',
      default: 1,
    },
    minSlidesOnMobile: {
      title: 'Minimum slides on mobile',
      description: 'Number of cards visible on screens ≤768px',
      type: 'number',
      default: 1,
    },
    autoplay: {
      title: 'Autoplay',
      type: 'boolean',
    },
    autoplayDelay: {
      title: 'Autoplay delay (ms)',
      type: 'number',
      default: 8000,
    },
    clickableSlides: {
      title: 'Make slides clickable',
      type: 'boolean',
      default: false,
    },
    hideDescription: {
      title: 'Hide description/content',
      type: 'boolean',
      default: false,
    },
    equalHeight: {
      title: 'Make all slides equal height',
      type: 'boolean',
      default: false,
    },
    showEffectiveDate: {
      title: 'Show effective date',
      type: 'boolean',
      default: false,
    },
    hideArrows: {
      title: 'Hide arrows',
      type: 'boolean',
    },
    hideDots: {
      title: 'Hide dots',
      type: 'boolean',
    },
    hideButtons: {
      title: 'Hide buttons',
      type: 'boolean',
      default: false,
    },
    backgroundColor: {
      title: 'Background colour',
      widget: 'select',
      choices: [
        ['#ffffff', 'White'],
        ['var(--lightgrey)', 'Light Grey'],
        ['var(--lightblue)', 'Light Blue'],
        ['var(--blue)', 'Blue'],
        ['var(--red)', 'Red'],
        ['var(--orange)', 'Orange'],
        ['var(--green)', 'Green'],
        ['var(--purple)', 'Purple'],
        ['var(--charcoal)', 'Charcoal'],
      ],
      default: '#E4EBEE',
    },
    textTone: {
      title: 'Title & dots colour',
      widget: 'select',
      choices: [
        ['light', 'Light'],
        ['dark', 'Dark'],
      ],
      default: 'dark',
    },
    appendManualSlides: {
      title: 'Append manual slides',
      description: 'Add manual slides after the listing results',
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default emblaCarouselSchema;
